<template>
  <div class="f1"></div>
</template>
<script setup>
</script>
